export const isExecutive = (permissions = [], role) => {
  return !!permissions.find(
    ({ slug, isVisibleForStaff }) => slug === role && isVisibleForStaff
  );
};

export const hasPermission = (permissions = [], route = '') => {
  const sanitize = (path) => path.replace(/^(\/)(.*)/, '$2');
  const pattern = new RegExp(`/?${sanitize(route)}$`);
  const permission = permissions.find(({ namespacePath }) => {
    return namespacePath && pattern.test(sanitize(namespacePath));
  });

  return permission && permission.isVisibleForStaff;
};



// WEBPACK FOOTER //
// ./src/utils/permission.js